import { useContext } from "react";

import { AuthContext } from "context/AuthContext";

const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    console.error("useAuthContext used outside of AuthProvider");
  }

  return context;
};

export default useAuthContext;
